import React from 'react';
import styles from './status-badge.module.css';
import { useTranslation } from 'react-i18next';

type StatusBadgeProps = {
  status: 'Active' | 'Inactive' | 'Deleted';
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <span className={`${styles.indicator} ${styles[status.toLowerCase()]}`}></span>
      <span className={styles.text}>{t(status.toLowerCase())}</span>
    </div>
  );
};
